import { graphql } from "@/gql";

export const featureFlagMutation = graphql(`
  mutation FeatureFlagMutation($input: UpdateFeatureFlagInput!) {
    updateFeatureFlag(input: $input)
  }
`);
